import React, {useEffect, useState} from "react";

import './CustomerDetailModal.scss'
import {useRecoilState, useRecoilValue} from "recoil";
import {
  viewCustomerDetailModalCustomerCodeState,
  viewCustomerDetailModalOpenState,
  viewCustomerDetailModalCustomerState
} from "../../../state/alerts_table";
import {Button, Column, Grid, Loading, Modal} from "@carbon/react";
import {grpcCustomerServiceSelector} from "../../../state/grpc";
import RichTextView from "../../RichTextView";
import {ADD, useToastContext} from "../../Toast";
import PropTypes from "prop-types";

const CustomerDetailModal = ({runningRecording, updateRunningRecording}) => {
  const [isOpen, setViewCustomerDetailModalOpen] = useRecoilState(viewCustomerDetailModalOpenState)
  const customerCode = useRecoilValue(viewCustomerDetailModalCustomerCodeState)
  const [customer, setViewCustomerDetailModalCustomer] = useRecoilState(viewCustomerDetailModalCustomerState)
  const customersService = useRecoilValue(grpcCustomerServiceSelector)
  const [loading, setLoading] = useState(true)
  const [startingRecording, setStartingRecording] = useState(false)
  const {toastDispatch} = useToastContext();

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setLoading(true)
    const req = new proto.api.GetCustomerRequest()
    req.setCode(customerCode)
    customersService.getCustomer(req, null, (err, resp) => {
      if (err != null) {
        console.log(err)
      } else {
        setViewCustomerDetailModalCustomer(resp.toObject().customer)
      }
      setLoading(false)
    })
  }, [isOpen]);

  if (!isOpen) {
    return (
      <></>
    )
  }

  if (loading) {
    return (
      <Loading withOverlay={true}/>
    )
  }

  return (
    <Modal
      open={isOpen}
      passiveModal
      modalLabel="Dati allarme"
      modalHeading="Dettagli sistema"
      onRequestClose={() => {
        setViewCustomerDetailModalOpen(false)
        setLoading(true)
      }}>
      <p style={{marginBottom: '2rem'}}>
        Questa interfaccia ti consente di visualizzare i dati più significativi del sistema selezionato. Se hai la
        necessità di modificare qualche informazione o aggiungere qualche dato mancate, vai alla pagina 'Sistemi'.
        In quella pagina ti sarà possibile trovare il record tramite il tool di ricerca e potrai modificare tutte le
        informazioni specificate.
      </p>
      <Grid>
        <Column lg={16} md={8} sm={8}>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Codice</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? customer.code : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Nome</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? customer.name : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Email sistema</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? customer.systemEmail : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Tipo sistema</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? customer.systemType : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Scadenza garanzia</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? customer.warrantyExpiration : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Servizio H24</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? (customer.serviceH24 ? "Si" : "No") : <Loading/>}
            </Column>
          </Grid>
          <Grid style={{marginBottom: '1rem'}}>
            <Column lg={4} md={4} sm={4}>
              <h6>Note</h6>
            </Column>
            <Column lg={12} md={4} sm={4}>
              {customer != null ? (customer.notes ?
                  <RichTextView text={customer.notes}/> : "Non sono state inserite note per questo sistema.") :
                <Loading/>}
            </Column>
          </Grid>
        </Column>
      </Grid>
      <Button type="button" kind="primary" disabled={startingRecording || runningRecording != null} onClick={() => {
        const req = new proto.api.StartRecordingRequest()
        req.setSystemcode(customer.code)
        req.setRecordingnotes("")
        setStartingRecording(true)
        customersService.startRecording(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            setStartingRecording(false)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile avviare la rendicontazione. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            navigator.clipboard.writeText(customer.systemLink)
              .then(r => {
                toastDispatch({
                  type: ADD,
                  payload: {
                    title: "Operazione avvenuta con successo",
                    content: `Rendicontazione avviata con successo. Il link del sistema è stato copiato sulla tua clipboard`,
                    kind: "success"
                  }
                })
              })
              .catch(err => {
                toastDispatch({
                  type: ADD,
                  payload: {
                    title: "Operazione avvenuta con successo",
                    content: `Rendicontazione avviata con successo`,
                    kind: "success"
                  }
                })
              })
              .finally(() => {
                updateRunningRecording(resp.toObject().recording)
                setStartingRecording(false)
                setViewCustomerDetailModalOpen(false)
              })
          }
        })
      }}>
        {
          startingRecording
            ? "Avvio rendicontazione in corso.."
            : (
              runningRecording != null
                ? "E' già attiva una rendicontazione"
                : "Avvia rendicontazione"
            )
        }
      </Button>
    </Modal>
  )
}

CustomerDetailModal.propTypes = {
  runningRecording: PropTypes.object,
  updateRunningRecording: PropTypes.func.isRequired,
}

export default CustomerDetailModal